// Date display helpers for the Darkspire dashboard. Storage everywhere is
// BIGINT epoch-ms (per the project conventions), so these helpers take/emit
// epoch-ms numbers only and render the canonical MM/DD/YYYY display format.

function pad2(n: number): string {
  return String(n).padStart(2, '0');
}

/**
 * "05/29/2026" — canonical short format used everywhere in the dashboard.
 * Falls back to an em dash for null/undefined/non-finite inputs so callers
 * can pass DB nulls without an extra guard.
 */
export function fmtDate(epochMs: number | null | undefined): string {
  if (epochMs === null || epochMs === undefined || !Number.isFinite(epochMs)) return '—';
  const d = new Date(epochMs);
  return `${pad2(d.getMonth() + 1)}/${pad2(d.getDate())}/${d.getFullYear()}`;
}

/**
 * "05/29/2026, 02:30 PM" — short date plus 12-hour time. Used for event
 * timelines, audit logs, and shift timestamps.
 */
export function fmtDateTime(epochMs: number | null | undefined): string {
  if (epochMs === null || epochMs === undefined || !Number.isFinite(epochMs)) return '—';
  const d = new Date(epochMs);
  const datePart = `${pad2(d.getMonth() + 1)}/${pad2(d.getDate())}/${d.getFullYear()}`;
  const timePart = d.toLocaleTimeString(undefined, {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
  return `${datePart}, ${timePart}`;
}

/**
 * "02:30 PM" — time only. Used for DAR shift start/end and entry rows where
 * the date is already established by the report context.
 */
export function fmtTime(epochMs: number | null | undefined): string {
  if (epochMs === null || epochMs === undefined || !Number.isFinite(epochMs)) return '—';
  return new Date(epochMs).toLocaleTimeString(undefined, {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
}
